module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fmt sgc-1",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "pre1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface#pre_1"
    }
  }, [_vm._v("Preface by Amy Scholder, editorial director of the Feminist Press")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter1#ch_1"
    }
  }, [_vm._v("Virgin Mary, Put Putin Away (Punk Prayer)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter2#ch_2"
    }
  }, [_vm._v("Pussy Riot: Art or Politics?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter3#ch_3"
    }
  }, [_vm._v("Letter by Masha in Prison")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter4#ch_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letters by Nadya in Prison")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter5#ch_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death to Prison, Freedom to Protest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter6#ch_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Patriarch Kirill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter7#ch_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kropotkin-Vodka")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter8#ch_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to President Medvedev")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter9#ch_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Putin Has Pissed Himself")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter10#ch_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opening Courtroom Statement by Masha")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter11#ch_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opening Courtroom Statement by Nadya")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter12#ch_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raze the Pavement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter13#ch_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpts from the Court Transcript")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter14#ch_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closing Statement by Defense Attorney Violetta Volkova")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter15#ch_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closing Statement by Defense Attorney Mark Feygin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter16#ch_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closing Statement by Defense Attorney Nikolay Polozov")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter17#ch_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closing Courtroom Statement by Katya")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter18#ch_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closing Courtroom Statement by Nadya")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter19#ch_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Closing Courtroom Statement by Masha")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter20#ch_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Poems by Masha")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter21#ch_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tributes to Pussy Riot: Yoko Ono, Johanna Fateman, JD Samson, Eileen Myles, Justin Vivian Bond, and Karen Finley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter23#ch_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author—Pussy Riot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter24#ch_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also Available from the Feminist Press")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter25#ch_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Feminist Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86c4cc94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0